import { generateAutomationName } from "../../helpers/generateAutomationName";

export const DEFAULT_MAX_CHARACTERS = 35;

export const TEST_SELECTORS = {
    inputWrapper: generateAutomationName("input", ["wrapper"]),
    inputElement: generateAutomationName("input", ["element"]),
    errorIcon: generateAutomationName("input", ["icon"]),
    errorName: generateAutomationName("input", ["error", "text"]),
};
